<div class="mxn-detail-panel">
  <h3 class="mxn-panel-heading">{{ heading }}</h3>
  <div class="mxn-inner-panel">
    <div class="">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </div>
</div>
